import React from "react";
import app from "nystem";
import { Link, OverlayClose, Wrapper, Icon } from "nystem-components";

const MenuItem = ({ to, icon, text, exact }) => (
  <OverlayClose renderAs="div">
    <Link className="" to={"/" + to} exact={exact}>
      <Icon className="w-6 h-6 m-3" icon={icon} />
      <Wrapper renderAs="b" className="rn-menu-item-text">
        {app.t(text)}
      </Wrapper>
    </Link>
  </OverlayClose>
);

const ViewLinkMenuItem = ({ value }) => (
  <MenuItem
    to={`page/render/${value._id}`}
    icon={({ "question-circle": "circle-question", "map-marker": "location-dot" })[value.icon] || value.icon}
    text={value.menutitle}
    exact={true}
  />
);
export default ViewLinkMenuItem;
